import { render, staticRenderFns } from "./GoodReceiptCreateView.vue?vue&type=template&id=14af06a1"
import script from "./GoodReceiptCreateView.vue?vue&type=script&lang=js"
export * from "./GoodReceiptCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports